var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcNavSetting24Px = function SvgIcNavSetting24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 19.2c.461-.517 2.621-2.893 3.254-2.893h6.692c.918 0 2.79 1.97 3.254 2.664m3-6.971a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0Zm-6.161-3.272C15.439 6.896 13.893 5.4 12 5.4c-1.892 0-3.438 1.496-3.438 3.328 0 1.831 1.546 3.328 3.438 3.328 1.893 0 3.439-1.497 3.439-3.328Z",
    stroke: "#828C97",
    strokeWidth: 1.5
  })));
};
export default SvgIcNavSetting24Px;